import React from 'react';
import { Container } from 'semantic-ui-react';
import { toSnakeCase } from '../helpers/common';
import DocumentsAndResourcesList from './DocumentsAndResourcesList';

const DocumentsAndResources = (props) => {
  const { title, module } = props;
  const { anchorTagLinkText, documentBlocks } = module;

  return (
    <section className="documents-and-resources" id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container>
        <div className="documents-and-resources__grid-wrapper">
          <div className="documents-and-resources__title-container">
            {title ? <h2 className="documents-and-resources__heading">{title}</h2> : null}
            {module?.introContent && <p className="documents-and-resources__intro-text body-two">{module.introContent}</p>}
          </div>
          <div className="documents-and-resources__documents-container">
            <DocumentsAndResourcesList documentBlocks={documentBlocks} />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default DocumentsAndResources;
